import { Hourglass } from "lucide-react";

import { ColocaAlert } from "@/shared/components/feedback/ColocaAlert";
import useTranslations from "@/shared/lang/useTranslations";
import { formatDateTime } from "@/shared/utils/dateTimeHelpers";

export interface BatchApprovalBannerProps {
  submittedAt: string | null;
  submittedByViewer: boolean;
}

/** A batch waiting for its second user, and why nothing on the page can be edited. */
export function BatchApprovalBanner({ submittedAt, submittedByViewer }: BatchApprovalBannerProps) {
  const { t, activeLanguage } = useTranslations("payoutBatches");
  const when = formatDateTime(submittedAt, { locale: activeLanguage, includeTime: true });

  return (
    <ColocaAlert
      variant="secondary"
      icon={Hourglass}
      heading={t("approval_banner_title")}
      text={
        submittedByViewer
          ? t("approval_banner_text_self", { when })
          : t("approval_banner_text_other", { when })
      }
    />
  );
}
